<script lang="ts" setup>
const { t } = useI18n()
</script>

<template>
  <div
    class="holder-map flex justify-center flex-col-reverse items-center xl:flex-row xl:items-start xl:justify-between xl:max-w-240.5 xl:mx-auto xl:w-full xl:mt-11"
  >
    <div class="mx-5.5 mt-10.5 mb-13 xl:mx-0 xl:mt-33 xl:mb-0">
      <div
        class="text-2xl leading-[42px] tracking-wider text-white text-center xl:text-left sm:text-[1.75rem]"
      >
        {{ t('holder') }}
        <span class="text-[#7540EE]">{{ t('map-shared-timelines') }}</span>
      </div>
      <div
        class="max-w-115 mt-9 text-lg leading-7 tracking-wide text-[#CECECE] text-center xl:text-left"
      >
        {{ t('turn-url-into-irl') }}
      </div>
    </div>
    <NuxtImg
      loading="lazy"
      :alt="t('holder') + ' ' + t('map-shared-timelines')"
      class="w-80.5 h-136.25 object-cover hidden xl:flex"
      src="/images/nft/phone-4.webp"
    />
    <div class="phone-2-mobile w-full flex justify-center xl:hidden">
      <NuxtImg
        loading="lazy"
        sizes="sm:100vw"
        :alt="t('holder') + ' ' + t('map-shared-timelines')"
        class="w-73.5 h-74 object-contain object-top"
        src="/images/nft/phone-6-mobile.webp"
      />
    </div>
  </div>
</template>

<style scoped>
@reference "tailwindcss";
.holder-map {
  @apply relative;
  &:after {
    @apply absolute w-full h-41.75 bottom-0 hidden;
    background: linear-gradient(180deg, rgba(21, 21, 21, 0) 0%, #151515 68.05%);
    content: '';
  }
}

.phone-2-mobile {
  @apply relative;
  &:after {
    @apply absolute left-0 bottom-0 w-full z-2 h-30 xl:hidden;
    background: linear-gradient(360deg, #151515 0%, rgba(34, 34, 34, 0) 100%);
    content: '';
  }
}

@media (min-width: 1279.9px) {
  .holder-map {
    &:after {
      @apply flex;
    }
  }
}
</style>
